import { Inject, Injectable, signal, WritableSignal } from '@angular/core';
import { STORAGE_KEYS } from '../constants';
import { SessionContext, StorageKeys } from '../models';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class SessionBackupService {
  public previousSessionContext: WritableSignal<SessionContext> = signal<SessionContext | null>(null);
  public readonly sessionRestored = signal(false);

  constructor(
    @Inject(STORAGE_KEYS) private readonly storageKeys: StorageKeys,
    private readonly storageService: StorageService) {
      this.init();
    }

  public clearOriginalSession(): void {
    this.previousSessionContext.set(null);
    this.storageService.removeItem(this.storageKeys.SESSION_BACKUP);
  }

  public storeOriginalSession(): void {
    const currentStoredSession = this.previousSessionContext();

    if (currentStoredSession?.refreshToken) {
      return;
    }

    const refreshToken = this.storageService.getItem(this.storageKeys.REFRESH_TOKEN);
    const branchName = this.storageService.getItem(this.storageKeys.BRANCH_NAME);

    if (!refreshToken) {
      return;
    }

    const backup = { refreshToken, branchName };
    this.previousSessionContext.set(backup);
    this.storageService.setItem(this.storageKeys.SESSION_BACKUP, JSON.stringify(backup));
  }

  public restoreOriginalSession(): void {
    const session = this.previousSessionContext();

    if (!session) {
      return;
    }

    this.storageService.setItem(this.storageKeys.BRANCH_NAME, session.branchName ?? null);
    this.storageService.setItem(this.storageKeys.REFRESH_TOKEN, session.refreshToken ?? null);
    this.clearOriginalSession();
    this.sessionRestored.set(true);
  }

  private init(): void {
    const backup = this.storageService.getItem<SessionContext>(this.storageKeys.SESSION_BACKUP);
    this.previousSessionContext.set(backup);
  }
}
